import { CATEGORIES, MESSAGE_TYPES } from './constants';


// Categories and keywords configuration
export const categories = {
  'Math': ['math', 'calculus', 'algebra', 'geometry', 'trigonometry', 'integration', 'proofs'],
  'Science': ['science', 'biology', 'chemistry', 'physics', 'lab'],
  'English': ['english', 'literature', 'writing', 'essay', 'reading'],
  'Sports': ['soccer', 'football', 'basketball', 'baseball', 'wrestling', 'sports', 'game', 'match'],
  'History': ['history', 'social studies', 'civilization'],
  'Spanish': ['spanish', 'language', 'conjugation']
};

  // Common names for recognition
export const commonNames = [
  "James", "John", "Robert", "Michael", "William", "David", "Joseph", "Mary",
  "Sarah", "Elizabeth", "Ruth", "Rebecca", "Rachel", "Leah", "Martha", "Eve",
  "Adam", "Noah", "Abraham", "Moses", "Daniel", "Peter", "Paul", "Matthew"
];

export const sentimentKeywords = {
  positive: ['wonderful', 'nice', 'smile', 'good', 'great', 'smart', 'helped', 'mature', 'excellent', 'improving','excited'],
  negative: ['worried', 'bad', 'poor', 'sad', 'upset', 'angry', 'worry', 'not', 'failed', 'mistake', 'hurt', 'struggl', 'hate']
};

// Analysis Functions
export const extractNames = (text) => {
  const words = text.split(/\s+/);
  const possibleNames = words
    .filter(word => {
      const lowercaseWord = word.toLowerCase();
      return commonNames.some(name => name.toLowerCase() === lowercaseWord);
    })
    .map(word => {
      const properName = commonNames.find(name => 
        name.toLowerCase() === word.toLowerCase()
      );
      return properName; // Returns the properly capitalized version from commonNames
    });
  
  return [...new Set(possibleNames)];
};

export const analyzeCategory = (text) => {
  const lowercaseText = text.toLowerCase();
  for (const [category, keywords] of Object.entries(categories)) {
    if (keywords.some(keyword => lowercaseText.includes(keyword))) {
      //console.debug(`Categorized as ${category}: "${text}"`);
      return category;
    }
  }
  return CATEGORIES.DEFAULT;
};

export const analyzeSentiment = (text) => {
  const lowercaseText = text.toLowerCase();
  const hasPositive = sentimentKeywords.positive.some(word => lowercaseText.includes(word));
  const hasNegative = sentimentKeywords.negative.some(word => lowercaseText.includes(word));
  
  if (hasPositive && !hasNegative) return MESSAGE_TYPES.POSITIVE;
  if (hasNegative && !hasPositive) return MESSAGE_TYPES.NEGATIVE;
  return MESSAGE_TYPES.NEUTRAL;
};